import { Component, NgModule, OnInit } from '@angular/core';
import { VERSION } from '../../../../../../src/environments/version';
import { select, Store } from '@ngrx/store';
import { getCurrentRouteState } from 'app/_selectors/router.selector';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { selectFooterVisible } from '../../../_selectors/layout.selectors';
import { environment } from '../../../../../../src/environments/environment';
import { EnvsEnum } from '../../../../../../src/environments/environment.interface';

@Component({
	selector: 'layout-footer',
	template: `
        <div *ngIf="footerVisible$ | async" class="footer-container">
            <ng-container *transloco="let t;read:'journal.footer'">
                <div class="footer-content-wrapper">
                    <div class="d-flex flex-column">
                        <span>{{t('contact')}}</span>
                        <a>support.cliniccare@eg.dk</a>
                    </div>
                    <span *ngIf="environment.name === EnvsEnum.testing || environment.name === EnvsEnum.dev">
                    {{ version.version + ' — ' + (version.buildDate | date: 'd MMMM, y — H:mm:ss') }}
                        <a *ngIf="!onAuthPage" [routerLink]="['/', 'changelog']">{{t('changelog')}}</a>
                    </span>
                </div>
            </ng-container>
        </div>
    `,
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
	version = VERSION;
	onAuthPage = false;
	footerVisible$ = this.store.select(selectFooterVisible);
	constructor(
		private store: Store
	) { }

	ngOnInit(): void {
		this.store.pipe(select(getCurrentRouteState)).subscribe(res => {
			if (!res) return;
			this.onAuthPage = res?.url.startsWith('/auth');
		});
	}

	protected readonly environment = environment;
	protected readonly EnvsEnum = EnvsEnum;
}
@NgModule({
	declarations: [FooterComponent],
	imports: [
		CommonModule,
		RouterModule,
		TranslocoModule
	],
	exports: [FooterComponent]
})
export class FooterComponentModule { }
